import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Mail, Phone, Globe, Cpu, ChevronRight, ChevronDown, ChevronUp } from 'lucide-react';

function Footer() {
  const currentYear = new Date().getFullYear();
  const [servicesOpen, setServicesOpen] = useState(false);
  const [systemOpen, setSystemOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <footer className="bg-[#F0F4F8] pt-10 pb-6 lg:pt-20 lg:pb-10">
      <div className="max-w-[1440px] mx-auto px-6">

        {/* TOP INTERFACE - THE CALL TO ACTION BLOCK */}
        <div className="flex flex-col lg:flex-row border-2 border-[#020617] bg-white shadow-[12px_12px_0px_0px_rgba(2,6,23,1)] overflow-hidden">
          {/* Left: Branding & Location */}
          <div className="lg:w-1/3 border-b-2 lg:border-b-0 lg:border-r-2 border-[#020617] p-6 lg:p-10 bg-[#020617] text-white flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-[#2B6CB0] flex items-center justify-center rounded-sm">
                  <Cpu size={24} className="text-white" />
                </div>
                <h2 className="text-3xl font-black uppercase tracking-tighter">Caffryx</h2>
              </div>
              {/* <p className="text-[#F0F4F8]/60 text-xs font-bold uppercase tracking-[0.4em] mb-10">
                Detroit Digital Engineering
              </p> */}
            </div>

            {/* Unique Location Block */}
            <div className="space-y-2 border-l-2 border-[#2B6CB0] pl-6">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 bg-[#2B6CB0] rounded-full animate-pulse"></span>
                <span className="text-[10px] font-black uppercase tracking-widest text-[#2B6CB0]">Station Active</span>
              </div>
              <p className="text-xl font-black uppercase tracking-widest leading-none">
                Metro <span className="text-[#2B6CB0]">Detroit</span>
              </p>
              {/* <p className="text-[9px] font-mono text-[#F0F4F8]/40">
                42.3314° N, 83.0458° W // 48226
              </p> */}
            </div>
          </div>

          {/* Right: Navigation Grid */}
          <div className="lg:w-2/3 p-6 lg:p-16 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12">
            {/* Services */}
            <div className="space-y-6">
              <Link
                to="/services"
                onClick={() => setServicesOpen(false)}
                className="lg:hidden flex items-center justify-between w-full text-[10px] font-black uppercase tracking-[0.4em] text-[#2B6CB0] hover:text-[#020617] transition-colors"
              >
                Services
                {servicesOpen ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
              </Link>
              <Link to="/services" className="hidden lg:block text-[10px] font-black uppercase tracking-[0.4em] text-[#2B6CB0] hover:text-[#020617] transition-colors">Services</Link>
              <ul className={`space-y-4 ${servicesOpen ? 'block' : 'hidden'} lg:block`}>
                {['Design', 'Development', 'Branding', 'SEO'].map((item) => (
                  <li key={item}>
                    <span className="group flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#4A5568]">
                      <ChevronRight size={14} className="text-[#2B6CB0]" />
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Support/Quick Links */}
            <div className="space-y-6">
              <button
                onClick={() => setSystemOpen(!systemOpen)}
                className="lg:hidden flex items-center justify-between w-full text-[10px] font-black uppercase tracking-[0.4em] text-[#2B6CB0]"
              >
                System
                {systemOpen ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
              </button>
              <h3 className="hidden lg:block text-[10px] font-black uppercase tracking-[0.4em] text-[#2B6CB0]">System</h3>
              <ul className={`space-y-4 ${systemOpen ? 'block' : 'hidden'} lg:block`}>
                {['Our Work', 'Insights', 'About', 'Contact'].map((item) => (
                  <li key={item}>
                    <Link to={`/${item.toLowerCase()}`} className="text-xs font-bold uppercase tracking-widest text-[#4A5568] hover:text-[#020617] transition-all">
                      {item}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Direct Contact */}
            <div className="space-y-6">
              <button
                onClick={() => setContactOpen(!contactOpen)}
                className="lg:hidden flex items-center justify-between w-full text-[10px] font-black uppercase tracking-[0.4em] text-[#2B6CB0]"
              >
                Direct Line
                {contactOpen ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
              </button>
              <h3 className="hidden lg:block text-[10px] font-black uppercase tracking-[0.4em] text-[#2B6CB0]">Direct Line</h3>
              <div className={`space-y-4 ${contactOpen ? 'block' : 'hidden'} lg:block`}>
                <a href="mailto:caffryx@gmail.com" onClick={() => setContactOpen(false)} className="flex items-center gap-3 text-xs font-black text-[#020617] hover:text-[#2B6CB0] transition-colors group">
                   <Mail size={16} /> caffryx@gmail.com
                </a>
                <a href="tel:8326176250" onClick={() => setContactOpen(false)} className="flex items-center gap-3 text-xs font-black text-[#020617] hover:text-[#2B6CB0] transition-colors group">
                   <Phone size={16} /> 832.617.6250
                </a>
              </div>
              <div className="pt-4">
                <Link to="/contact" onClick={() => setContactOpen(false)} className="inline-flex items-center gap-2 bg-[#2B6CB0] text-white px-4 py-2 text-[10px] font-black uppercase tracking-widest hover:bg-[#020617] transition-all">
                  Start Build <ArrowUpRight size={14} />
                </Link>
                {/* BOTTOM RIGHT LOGO */}
                <div className="mt-4 bg-black border-2 border-white px-4 py-3 w-fit" style={{ filter: 'drop-shadow(4px 4px 0px #ffffff)' }}>
                  <p className="text-xs font-bold text-white uppercase tracking-widest">
                    developed by
                  </p>
                  <a href="https://caffryx.com" className="text-xl font-black text-white uppercase tracking-tighter leading-none mt-1 hover:text-[#2B6CB0] transition-colors">
                    Caffryx.
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;